import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import RefreshIcon from '@mui/icons-material/Refresh';
import { IconButton } from '@mui/material';
import { BASE_ADMIN_API_URL } from '../../../../config';
import { useFetch } from '../../../../hooks/use-fetch';

export const useSensorLoadListAction = (sn) => {
    const fetch = useFetch();
    return useCallback(async () => {
        try {
            const response = await fetch(
                `${BASE_ADMIN_API_URL}/actions/devices/${sn}/sensors/list/`,
                {
                    method: 'GET',
                });

            if (!response.ok) {
                throw new Error(await response.text());
            }
        } catch (e) {
            console.error(e);
        }
    }, []);
}

export default function SensorsLoadListIconButton({ sn }) {
    const action = useSensorLoadListAction(sn);

    return (
        <IconButton onClick={action} aria-label="reload sensors">
            <RefreshIcon />
        </IconButton>
    )
}

SensorsLoadListIconButton.propTypes = {
    sn: PropTypes.string
}
